import api from './axios';

// Effect interface
export interface Effect {
  state_id: number;
  name: string;
  tooltip: string;
  icon_file_name: string;
  is_harmful: string;
}

// Effect response interface
export interface EffectsResponse {
  page: number;
  size: number;
  total: number;
  effects: Effect[];
}

// Effect search params interface
export interface EffectSearchParams {
  page?: number;
  size?: number;
  search?: string;
  type?: 'BUFF' | 'DEBUFF';
  language?: string;
}

// Effect add/remove params interface
export interface EffectCommandParams {
  stateId: number;
  level: number;
  duration?: number;
  characterId: number;
  characterName: string;
  applyToPet?: boolean;
}

// Command response interface
export interface CommandResponse {
  message: string;
  command: string;
}

export interface GroupEffect {
  type: 'GROUP';
  name: string;
  tooltip: string;
  icon_file_name: string; // иконка группы (от первого эффекта)
  group_effects: { state_id: number; level: number }[];
}

export type EffectWithGroup = Effect | GroupEffect;

/**
 * Get effects with pagination, search, and filters
 * @param params Search parameters
 * @returns Effects response
 */
export const getEffects = async (params: EffectSearchParams = {}): Promise<EffectsResponse> => {
  // Define query parameters
  const queryParams = new URLSearchParams();
  
  // Add parameters to query
  if (params.page) queryParams.append('page', params.page.toString());
  if (params.size) queryParams.append('size', params.size.toString());
  if (params.search) queryParams.append('search', params.search);
  if (params.type) queryParams.append('type', params.type);
  if (params.language) queryParams.append('language', params.language);
  
  // Make API call
  const response = await api.get<EffectsResponse>(`/effects?${queryParams.toString()}`);
  return response.data;
};

/**
 * Add an effect to a character
 * @param params Effect parameters
 * @returns Command response
 */
export const addEffect = async (params: EffectCommandParams): Promise<CommandResponse> => {
  const response = await api.post<CommandResponse>('/effects/add', params);
  return response.data;
};

/**
 * Remove an effect from a character
 * @param params Effect parameters
 * @returns Command response
 */
export const removeEffect = async (params: Omit<EffectCommandParams, 'duration'>): Promise<CommandResponse> => {
  const response = await api.post<CommandResponse>('/effects/remove', params);
  return response.data;
}; 